import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { BaseObject } from 'src/app/models/base-object.model';
import { StrategyCode } from 'src/app/models/strategy/strategy-code.model';
import { Format } from 'src/app/rgs/components/objects/object-item/object-inspection/components/print-dialog/models/print-format';
import { Inspection } from 'src/app/rgs/components/objects/object-item/object-inspection/models/inspection.model';

@HateoasResource('task')
export class Task extends BaseObject {
  public uuid!: string;
  public priority!: TaskPriority;
  public reportStatus!: TaskStatus;
  public format!: Format;
  public type!: TaskReportType;
  public license!: string;
  public service!: string;
  public report!: string;
  public username!: string;
  public inspectionId!: string;
  public strategyId!: string;
  public rgsObjectId!: string;
  public result!: string;
  public reportName!: string;
  public created!: Date;
  public userId!: string;

  public strategyResolved?: StrategyCode;
  public inspectionResolved?: Inspection;

  public static getMimeType(task: Task): string {
    switch (task.format) {
      case Format.DOCX:
        return 'docx';
      case Format.PDF:
        return 'pdf';
      case Format.XLSX:
        return 'xlsx';
      default:
        return 'pdf';
    }
  }

  public static getMimeTypeFormat(format: Format): string {
    switch (format) {
      case Format.DOCX:
        return 'docx';
      case Format.PDF:
        return 'pdf';
      case Format.XLSX:
        return 'xlsx';
      default:
        return 'pdf';
    }
  }
}

export enum TaskPriority {
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
}

export enum TaskStatus {
  DOWNLOADED = 'DOWNLOADED',
  COMPLETE = 'COMPLETE',
  RUNNING = 'RUNNING',
  QUEUED = 'QUEUED',
  FAIL = 'FAIL',
}

export enum TaskReportType {
  INSPECTION = 'INSPECTION',
  STRATEGY = 'STRATEGY',
  SCENARIO = 'SCENARIO',
  DATA_ANALYSIS = 'DATA_ANALYSIS',
}
